<template>
  <b-container class="filter"></b-container>
</template>

<script>
export default {
  name: "export_filter",
};
</script>

<style scoped>
.filter {
  background-color: #f9f9f9;
}
</style>
